import Game from "./pages/Game"

import React, { Component, MouseEvent } from 'react';
import './App.css';

const App = () => {
    return <Game />
}

export default App;
